import page from './page'
import news from './news'
import home from './home'
import academy from  './academy.js'
import honor from './honor'
import team from './team'
import about from './about'

export default [
  page,
  news,
  home,
  academy,
  honor,
  team,
  about
]